<template>
  <div class="workbench-container">
    <div class="section card">
      <div class="section-title">{{$t('message.workbench.attendance')}}</div>
      <div class="button-group">
        <div class="button-item green" @click="showToast">
          <img src="@/assets/workbench/daka.png">
          <span>{{$t('message.workbench.punch')}}</span>
        </div>
        <div class="button-item blue" @click="showToast">
          <img src="@/assets/workbench/buka.png">
          <span>{{$t('message.workbench.makeupPunch')}}</span>
        </div>
        <div class="button-item yellow" @click="showToast">
          <img src="@/assets/workbench/qingjia.png">
          <span>{{$t('message.workbench.leave')}}</span>
        </div>
        <div class="button-item red" @click="showToast">
          <img src="@/assets/workbench/jiaban.png">
          <span>{{$t('message.workbench.overtime')}}</span>
        </div>
      </div>
    </div>

    <div class="section card">
      <div class="section-title">{{$t('message.workbench.hrManagement')}}</div>
      <div class="button-group">
        <div class="button-item blue" @click="showToast">
          <img src="@/assets/workbench/zhaopin.png">
          <span>{{$t('message.workbench.recruitment')}}</span>
        </div>
        <div class="button-item green" @click="showToast">
          <img src="@/assets/workbench/zhunzheng.png">
          <span>{{$t('message.workbench.becomeRegular')}}</span>
        </div>
        <div class="button-item purple" @click="showToast">
          <img src="@/assets/workbench/diaoli.png">
          <span>{{$t('message.workbench.transfer')}}</span>
        </div>
        <div class="button-item blue" @click="showToast">
          <img src="@/assets/workbench/xinzhi.png">
          <span>{{$t('message.workbench.salaryAdjustment')}}</span>
        </div>
      </div>
    </div>

    <div class="section card">
      <div class="section-title">{{$t('message.workbench.financeManagement')}}</div>
      <div class="button-group">
        <div class="button-item yellow" @click="showToast">
          <img src="@/assets/workbench/fukuan.png">
          <span>{{$t('message.workbench.payment')}}</span>
        </div>
        <div class="button-item orange" @click="showToast">
          <img src="@/assets/workbench/feiyong.png">
          <span>{{$t('message.workbench.reimbursement')}}</span>
        </div>
        <div class="button-item green" @click="showToast">
          <img src="@/assets/workbench/caigou.png">
          <span>{{$t('message.workbench.purchase')}}</span>
        </div>
        <div class="button-item green" @click="showToast">
          <img src="@/assets/workbench/beiyong.png">
          <span>{{$t('message.workbench.pettyCash')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';

export default {
  name: 'Workbench',
  data() {
    return {}
  },
  created() {
    // 获取路由参数 lang
    let lang = this.$route && this.$route.query && this.$route.query.lang;
    let locale = '';
    if (lang) {
      if (lang === 'zh-Hans') {
        locale = 'zh-CN';
      } else if (lang === 'zh-Hant') {
        locale = 'zh-TW';
      }
      if (locale) {
        this.$i18n.locale = locale;
        localStorage.setItem('user_lang', locale);
      } else {
        // 不支持的 lang 默认 zh-CN
        this.$i18n.locale = 'zh-CN';
        localStorage.setItem('user_lang', 'zh-CN');
      }
    } else {
      // 没有参数则读取缓存
      let cacheLang = localStorage.getItem('user_lang');
      if (cacheLang === 'zh-CN' || cacheLang === 'zh-TW') {
        this.$i18n.locale = cacheLang;
      } else {
        // 没有缓存则默认简体中文
        this.$i18n.locale = 'zh-CN';
        localStorage.setItem('user_lang', 'zh-CN');
      }
    }
  },
  methods: {
    showToast() {
      Toast(this.$t('message.workbench.noPermission'));
    },
    goToPage(page) {
      // 页面跳转逻辑，根据实际路由配置调整
      if (page !== 'workbench') {
        this.showToast();
      }
    }
  }
}
</script>

<style scoped>
.workbench-container {
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  font-family: PingFang SC, Helvetica Neue, Arial, sans-serif;
  padding: 12px;
  min-height: 100vh;
  box-sizing: border-box;
}

.section {
  background-color: #fff;
  padding: 20px 15px;
  margin-bottom: 15px;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.section-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 500;
}

.button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.button-item {
  width: 22%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: unset;
  border-radius: 8px;
  cursor: pointer;
  box-sizing: border-box;
}

.tab-bar {
  display: flex;
  height: 50px;
  background-color: #fff;
  border-top: 1px solid #eee;
  position: fixed;
  bottom: 0;
  width: 100%;
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: unset;
  color: #999;
}

.tab-item.active {
  color: #1989fa;
}

.tab-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #eee;
  margin-bottom: 2px;
}

.tab-text {
  font-size: 10px;
}

.notice-content p {
  margin: 0;
  padding: 2px 0;
}

.button-item img {
  width: 56px;
  height: 56px;
  margin-bottom: 8px;
}

.button-item span {
  font-size: 14px;
  /* color: #fff; */
  text-align: center;
}
</style>
